import { action, observable } from 'mobx';

import { UserQuizData } from '../adl-gen/totalinteraction/futurefit/frontend';
import { fromPromise, MaybeLoading } from '../loader/loader';
import { Service } from '../service/service';

import { LoggedIn } from './identity-store';

// tslint:disable-next-line: no-any
function ignoreUnused(_i: any) {}

/**
 * Data and actions for user home screen data
 */
export class UserQuizDataStore {
  /** Response from the server */
  @observable.ref data: MaybeLoading<UserQuizData> = {
    kind: 'loading'
  };

  constructor(private readonly service: Service, private readonly identity: LoggedIn) {
    this.load();
    ignoreUnused(this.identity);
  }

  @action load() {
    this.data = fromPromise(this.loadUserQuizData());
  }

  loadUserQuizData = async (): Promise<UserQuizData> => {
    const quizzes = await this.service.queryQuizzesForUser(this.identity.appUserWithDbId.id);

    return {
      appUserId: this.identity.appUserWithDbId.id,
      fullname: this.identity.appUserWithDbId.value.fullname,
      userQuizzes: quizzes.items
    };
  };
}



// WEBPACK FOOTER //
// ./src/stores/user-quiz-data-store.ts